import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M17.709 20.263H6.291a2.557 2.557 0 0 1-2.554-2.554V6.291a2.557 2.557 0 0 1 2.554-2.554h11.418a2.557 2.557 0 0 1 2.554 2.554v11.418a2.557 2.557 0 0 1-2.554 2.554zM6.291 4.768a1.524 1.524 0 0 0-1.523 1.523v11.418a1.524 1.524 0 0 0 1.523 1.523h11.418a1.524 1.524 0 0 0 1.523-1.523V6.291a1.524 1.524 0 0 0-1.523-1.523z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.528 12.483H7.475a.515.515 0 1 1 0-1.03h9.053a.515.515 0 1 1 0 1.03z"
  })]
}), 'CheckboxIndeterminate');
//# sourceMappingURL=index.js.map